import React from "react";
import frontiniLogo from "../assets/img/frontini-logo.svg";

function Footer() {
  return (
    <div className="bg-white shadow-lg p-4  rounded-lg flex justify-center">
      <div className="text-blue-800 text-center">
        <img src={frontiniLogo} className="h-14" alt="Logo Frontini y asoc" />
        <p className="font-bold text-sm">Frontini S.R.L</p>
        <p className="font-light text-sm">Dirección Calle 14 N° 622 1/2 </p>
        <p className="font-light text-sm">La Plata, Bs. As. – Argentina</p>
      </div>
    </div>
  );
}
export default Footer;
